import React, { useEffect, useState } from 'react';
import {
  CssBaseline,
  Typography,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  IconButton,
  Divider,
  Box,
  Toolbar,
  List,
} from '@mui/material';
import { useHistory, withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import MenuIcon from '@mui/icons-material/Menu';
import { Logo, LanguageButton, UserProfile } from 'components/common';
import packageJson from '../../../../package.json';
import useStyles, { DrawerHeader, Drawer, AppBar, drawerWidthCollapse, IS_DRAWER_OPEN } from './styles';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import AutoAwesomeMotionOutlinedIcon from '@mui/icons-material/AutoAwesomeMotionOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SlowMotionVideoOutlinedIcon from '@mui/icons-material/SlowMotionVideoOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { nikoMenuItem } from 'features/niko';



function createRouteMap() {
  const routes = {};

  for (const key in ROUTES) {
    routes[ROUTES[key]] = key.toLowerCase().replace(/[_-]([^_-])/g, function($0,$1){return $1.toUpperCase()});
  }
  return routes;
}

const routesMap = createRouteMap();

function ResponsiveDrawer(props) {
  const classes = useStyles();
  const [t] = useTranslation();
  const [open, setOpen] = useState(
    JSON.parse(localStorage.getItem(IS_DRAWER_OPEN))
  );
  const [routeSelected, setRouteSelected] = useState(null);
  const [isHover, setIsHover] = useState(false);
  const [labelTop, setLabelTop] = useState();
  const history = useHistory();
  const { user } = useUser();
  const { children } = props;

  const formatRoute = (view) => {
    const pathname = history.location.pathname;
    const route = routesMap[pathname];

    if (route) {
      document.title = t(`${route}.titleTab`);
      setLabelTop(`${route}.labelTopbar`);
    }
  };

  const handleOpenDrawer = () => {
    setOpen(!open);
    localStorage.setItem(IS_DRAWER_OPEN, !open);
  };

  const handleRoutesLabel = (item) => {
    if (routeSelected !== item.route) {
    }
    window.scrollTo(0, 0);
    history.replace(item.route);
    setRouteSelected(item.route);
  };

  useEffect(() => {
    formatRoute();

    return () => {
      // cleanUp();
      // setLabelTop(null);
      // setOpen(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname]);


  const validGlobalPermision = (viewName)=>{
    if (user.admin){
      return true;
    }else{
      try{
        const perm = user.roles[0].permission.filter(item => item.projectId === -1)[0].permissions.filter(item => item.view === viewName)[0];
        return perm && perm.isVisible ? true : false;
      }catch(err){
        console.log(err)
        return false;
      }
    }
  }

  const routesNavigation = [
    {
      view: 'home',
      label: t('navbar.drawer.home'),
      icon: <HomeOutlinedIcon />,
      route: ROUTES.HOME,
      restrict: false
    },
    // Niko es una feature opcional: en la build core `nikoMenuItem()` devuelve null y el
    // filtro de abajo lo saca de la lista. Ver features/niko.
    nikoMenuItem(t),
    { view: 'divider' },
    {
      view: 'job',
      label: t('navbar.drawer.job'),
      icon: <WorkHistoryOutlinedIcon />,
      route: ROUTES.JOB_LIST,
      restrict: false
    },
    {
      view: 'macro',
      label: t('navbar.drawer.macro'),
      icon: <SlowMotionVideoOutlinedIcon />,
      route: ROUTES.MACRO_EXECUTE,
      restrict: !validGlobalPermision('macros')
    },
    { view: 'divider' },
    {
      view: 'templateList',
      label: t('navbar.drawer.template'),
      icon: <ViewInArIcon />,
      route: `${ROUTES.TEMPLATE_LIST}`,
      restrict: false
    },
    {
      view: 'workflowList',
      label: t('navbar.drawer.workflow'),
      icon: <AccountTreeOutlinedIcon />,
      route: ROUTES.WORKFLOW_LIST,
      restrict: false
    },
    { view: 'divider' },
    {
      view: 'inventoryList',
      label: t('navbar.drawer.inventory'),
      icon: <DnsOutlinedIcon />,
      route: ROUTES.INVENTORY_LIST,
      restrict: !validGlobalPermision('inventories')
    },
    {
      view: 'dataModelList',
      label: t('navbar.drawer.dataModel'),
      icon: <TextSnippetOutlinedIcon />,
      route: ROUTES.DATA_MODEL_LIST,
      restrict: false
    },
    {
      view: 'documentationList',
      label: t('navbar.drawer.documentation'),
      icon: <FolderOpenOutlinedIcon />,
      route: ROUTES.DOCUMENTATION_LIST,
      restrict: false
    },
    {
      view: 'credentialList',
      label: t('navbar.drawer.credential'),
      icon: <HttpsOutlinedIcon />,
      route: ROUTES.CREDENTIAL_LIST,
      restrict: !validGlobalPermision('credentials')
    },
    {
      view: 'projectList',
      label: t('navbar.drawer.project'),
      icon: <AutoAwesomeMotionOutlinedIcon />,
      route: ROUTES.PROJECT_LIST,
      restrict: !user.admin
    },
    {
      view: 'company',
      label: t('navbar.drawer.company'),
      icon: <ApartmentOutlinedIcon />,
      route: ROUTES.COMPANY_LIST,
      restrict: !user.admin
    },
    { view: 'divider', restrict: !user.admin },
    {
      view: 'userList',
      label: t('navbar.drawer.user'),
      icon: <GroupOutlinedIcon />,
      route: ROUTES.USER_LIST,
      restrict: !user.admin
    },
    {
      view: 'roles',
      label: t('navbar.drawer.roles'),
      icon: <AssignmentIndIcon />,
      route: ROUTES.ROLE_LIST,
      restrict: !user.admin
    },
    { view: 'divider', restrict: !user.admin },
    {
      view: 'apiTokenList',
      label: t('navbar.drawer.apiReference'),
      icon: <MenuBookOutlinedIcon />,
      route: ROUTES.API_TOKEN_LIST,
      restrict: !user.admin
    },
    { view: 'divider', restrict: !user.admin },
    {
      view: 'configuration',
      label: t('navbar.drawer.configuration'),
      icon: <SettingsOutlinedIcon />,
      route: ROUTES.CONFIGURATION,
      restrict: !user.admin
    },
  ];

  const handleDrawer = () => handleOpenDrawer();

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar className={classes.toolbar}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawer}
              edge="start"
              sx={{
                marginRight: 2,
                ...((open || isHover) && {
                  transform: 'rotateZ(90deg)',
                  transition: '.3s',
                }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="subtitle1" noWrap sx={{ display: 'flex', alignItems: 'center' }}>
              {t(labelTop)}
            </Typography>
          </Box>


          <Box sx={{ display: 'flex', gap: 2 }}>
            <LanguageButton/>
            <UserProfile username={user.username} />
          </Box>

        </Toolbar>
      </AppBar>
      {!open && <Box sx={{ minWidth: drawerWidthCollapse }} />}

      <Drawer
        variant="permanent"
        open={open || isHover}
        sx={{ position: !open ? 'absolute' : 'inherit' }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        className={classes.scrollbar}
      >
        <DrawerHeader />
        <List className={classes.scrollbar}>
          <ListItem key="logo" disablePadding>
            <ListItemButton
              sx={{
                '&:hover': { background: 'inherit' },
              }}
              onClick={() => handleRoutesLabel(routesNavigation[0])}
            >
              <ListItemIcon>
                <Logo className={classes.logo} width={'100px'} />
              </ListItemIcon>
              <Typography variant="h6" sx={{ flex: '1 1 100%', fontFamily: 'monospace', fontWeight: '400' }}>
                {packageJson.name}
              </Typography>
            </ListItemButton>
          </ListItem>
          <Divider/>
          {/* `.filter(Boolean)`: las entradas de features opcionales devuelven null
              cuando la build no las incluye (ver nikoMenuItem). */}
          {routesNavigation.filter(Boolean).map((item, index) => (
            <React.Fragment key={item.view + index}>
              { item.restrict ?
                (
                  <></>
                )
                : item.view === 'divider' ? (
                  <Divider/>
                )
                :(
                  <ListItem key={item.label} disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open || isHover ? 'initial' : 'center',
                        px: 2.5,
                      }}
                      onClick={() => handleRoutesLabel(item)}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open || isHover ? 3 : 'auto',
                          justifyContent: 'center',
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.label}
                        sx={{ opacity: open || isHover ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                )
              }
            </React.Fragment>
          ))}
        </List>
      </Drawer>
      {children}
    </Box>
  );
}

export default withRouter(ResponsiveDrawer);
